var canvas = new fabric.StaticCanvas("paver-replica-canvas");
var shiftText = [28, 33, 35];
var shiftText = [30, 32, 36];
var maxCharLimit = 16;
var shiftDivider = (1 / maxCharLimit);

var imgUrl = "//cdn.shopify.com/s/files/1/1154/7492/t/3/assets/brick_bg.jpg?v=11131074533305418171457794948";

fabric.Image.fromURL(imgUrl, function(img) {
  var zoomFactorX = canvas.width / img.width;
  var zoomFactorY = canvas.height / img.height;

  var zoomFactor = (zoomFactorX < zoomFactorY) ? zoomFactorX : zoomFactorY;

   img.set({
     originX: 'left',
     originY: 'top',
     scaleY: zoomFactor,
     scaleX: zoomFactor
   });
   canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
   var fontOptions = {
     fontFamily: 'Wasabi',
     fontSize: 42,
     fontWeight: 'normal',
     textAlign: 'center',
     strokeWidth: 1,
     fill: 'rgba(31,24,28,0.85)',
     stroke: 'rgba(31,24,28,1)',
     shadow: 'rgba(255,255,255,0.4) 1px 2px 2px'
   };

   WebFont.load({
    custom: {
      families: ["Wasabi"],
      urls: ["//cdn.shopify.com/s/files/1/1154/7492/t/3/assets/fonts.css?v=157661098128349147881623434250"]
    },
    active: function() {
		var text01 = 'ABBY BECK';
		var text02 = 'PROUD TIGER';
		var text03 = 'AB 2015';
		
		var line01 = new fabric.Text(text01, fontOptions);
		var line02 = new fabric.Text(text02, fontOptions);
		var line03 = new fabric.Text(text03, fontOptions);

        line01.set({
          id: 'line01',
          angle: 3,
          top: 72,
          left: (((canvas.width - line01.width) / 2) - (shiftText[0] / (1 + (text01.length * shiftDivider))))
        });

        line02.set({
          id: 'line02',
          angle: 4.3,
          top: 120,
          left: (((canvas.width - line02.width) / 2) - (shiftText[1] / (1 + (text02.length * shiftDivider))))
        });

        line03.set({
          id: 'line03',
          angle: 6.1,
          top: 172,
          left: (((canvas.width - line03.width) / 2) - (shiftText[2] / (1 + (text03.length * shiftDivider))))
        });

        canvas.add(line01);
        canvas.add(line02);
        canvas.add(line03);
    }
   });
});

function changeTextOnLine(lineNum, textBoxId) {
  var newText = jQuery("#" + textBoxId).val();
  
  // Adding a check to limit entry to maxCharLimit characters
  if(newText.length > maxCharLimit) {
    newText = newText.substring(0, maxCharLimit);
    jQuery("#" + textBoxId).val(newText.substring(0, maxCharLimit));
  }
  
  canvas.getObjects().forEach(function(o) {
    if (o.type === 'text' && o.id == 'line0' + lineNum) {
      o.text = newText;
      o.left = (((canvas.width - o.width) / 2) - ((shiftText[lineNum - 1] / (1 + (newText.length * shiftDivider)))));
      canvas.renderAll();
    }
  });
}

jQuery(document).ready(function() {
  var inputBoxes = jQuery("form[action='/cart/add'] input[type='text']");
  
  jQuery.each(inputBoxes, function(i, val) {
    jQuery(val).keyup(function() {
      var boxId = jQuery(this).attr("id");
      return changeTextOnLine(i + 1, boxId);
    });
  });
});